import PeriodResults from '@/components/kpi/period-results/PeriodResults.vue';
import KpiBaseDataEdit from '@/components/kpi/employees-kpi/kpi-base-data-edit/KpiBaseDataEdit.vue';
import TableviewExtended from '@/components/common/TableviewExtended/TableviewExtended.vue';

export default {
  name: 'KpiReport',
  components: { KpiBaseDataEdit, PeriodResults, TableviewExtended },
  data () {
    return {
      isMounted: false,
      isLoading: false,
      isFileLoading: false,
      paging: {
        page: 1,
        pages: 1,
        limit: 20,
        total: 0
      },
      tableSorting: { item: 'title', direction: 'asc' },
      filterValues: {
        period: null,
        resultStatuses: null,
        userFullName: null,
        periodTypes: null,
        companies: null
      },
      tableItems: [],
      downloadFilters: {
        startDate: null,
        endDate: null
      },
      tableClassDefault: 'table-striped table-hover',
      tableClass: this.tableClassDefault
    }
  },
  computed: {
    periodTypesOptions () {
      const types = this.$store.getters.getConfigOptions('period_types');
      types.forEach(type => {
        type.text = this.$t('general.period_types.' + type.value);
        type.code = type.value;
      });
      return types;
    },
    companies () {
      return this.$store.getters.getConfigOptions('user_companies', this.$i18n.locale, 'disabled', '0');
    },
    kpiResultStatuses () {
      return this.$store.getters.getConfigOptions('kpi_result_statuses', this.$i18n.locale);
    },
    canViewAll () {
      return this.ApiRequest.userHasPermission('view-all-kpi');
    },
    tableExpandConfig () {
      return { component: 'slot' };
    },
    requestPath () {
      const path = 'kpi/report?perPage=' + this.paging.limit + '&page=' + this.paging.page;
      return this.ApiRequest.addGetParamsToPath(
        path,
        (this.$refs.tableview ? this.$refs.tableview.getFilterValues() : this.filterValues),
        true
      );
    },
    tableHeaders () {
      const headers = [
        { key: 'period.name', label: this.$t('Periods'), format: 'formatFunc', funcs: [this.getPeriodName], class: 'col-width-xl', filterKey: 'period' },
        { key: 'user.fullname', label: this.$t('Vārds'), class: 'col-width-xl', filterKey: 'userFullName' },
        { key: 'user.ldapUsername', label: this.$t('Darbinieka ID'), class: 'col-width-xl' },
        { key: 'payout', label: this.$t('Summa'), class: 'col-width-xl' },
        { key: 'period.type', label: this.$t('kpi.job_position_period_type'), format: 'formatFunc', funcs: [this.getPeriodType], class: 'col-width-xl', filterKey: 'periodTypes' },
        { key: 'status_id', label: this.$t('general.status'), class: 'col-width-xl', format: 'formatFunc', funcs: [this.getStatus], filterKey: 'resultStatuses' }
      ];

      const actions = [];
      actions.push({
        ifconfig: { useFunc: true, func: this.canEdit },
        label: this.$t('kpi.edit-user-kpi-base-data'),
        emit: 'editItem',
        bicon: 'pencil-fill',
        class: 'btn-warning btn-sm'
      });
      headers.push({ key: 'actions', label: '', actions: actions, headerClass: 'col-1' });
      return headers;
    },
    tableActions () {
      return { download: this.ApiRequest.userHasPermission('download-kpi') };
    },
    tableFilterConfig () {
      const filters = {}

      filters.period = {
        type: 'date-range',
        colOnlyFilter: true,
        label: this.$t('Periods'),
        class: 'col-md-2'
      }
      filters.resultStatuses = { type: 'checkbox', label: '', options: this.kpiResultStatuses, colOnlyFilter: true }
      filters.userFullName = {
        type: 'text',
        colOnlyFilter: true,
        label: this.$t('user.name'),
        class: 'col-md-2'
      }
      filters.periodTypes = {
        type: 'select',
        label: this.$t(''),
        colOnlyFilter: true,
        options: this.periodTypesOptions,
        class: 'col-md-8'
      }
      if (this.canViewAll) {
        filters.companies = {
          type: 'checkbox',
          label: this.$t('company-structure.company.name'),
          colOnlyFilter: false,
          options: this.companies,
          class: 'col-md-8'
        }
      }
      if (Object.keys(filters).length < 1) {
        return null;
      }

      return filters;
    }
  },
  methods: {
    getPeriodName (period) {
      return period[this.$i18n.locale];
    },
    getStatus (status) {
      return this.$store.getters.getDataFromConfigWithFilter('kpi_result_statuses', 'id', status)?.name[this.$i18n.locale];
    },
    canEdit (item) {
      return (item?.kpi_direct_manager_id === null && item?.direct_manager_id == this.$session.get('userId')) ||
        (item?.kpi_direct_manager_id == this.$session.get('userId'))
    },
    download (html, exportCols) {
      const path = this.ApiRequest.addGetParamsToPath(this.requestPath, this.filterValues);
      this.$refs.tableview.downloadTableData(path, exportCols);
    },
    updateUserCompanyJobPosition (el) {
      //
    },
    editItem (el) {
      this.$refs.editElFrm.show(el);
    },
    getPeriodType (val) {
      if (val) {
        return this.$t('general.period_types.' + val);
      }
    },
    getTableData () {
      this.isLoading = false;
      if (this.currentReq) {
        this.currentReq.cancel('changed search query');
      }
      this.isLoading = true;
      this.$forceUpdate();
      this.currentReq = this.ApiRequest.request(this.requestPath, this.ApiRequest.REQUEST_GET, [], (response) => {
        if (response.data) {
          this.tableItems = response.data;
          this.paging = response.paging;
          this.isLoading = false;
        }
      });
    },
    changePage (pageNr) {
      this.paging.page = pageNr;
      this.getTableData();
    },
    updateFilters () {
      this.BasicHelper.updateFilterValues(this.$route.name, this.filterValues);
      this.getTableData();
    },

    clearFilters () {
      this.tableClass = this.tableClassDefault;
      this.filterValues = {};
      this.getTableData();
    }
  },
  mounted () {
    this.filterValues = this.BasicHelper.fillFilterValues(this.$route.name, this.filterValues, this.$session);
    this.getTableData();
    this.isMounted = true;
  }
}
